// This file was automatically generated from fax.letter.html.
// Please don't edit this file by hand.

goog.provide('el8.template.fax.letter');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print.letter.attachments');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.fax.letter.passportCta = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.passportUrl) {
    output.append('<div class="mt30"><p class="emphasis pb10">Note: Interactive patient chart available online</p>');
    if (opt_data.patientCopy) {
      output.append('<p>', soy.$$escapeHtml(opt_data.sendingPhysician.fullName), ' has prepared an interactive patient chart for ', soy.$$escapeHtml(opt_data.recipient.fullName), ', available at ', soy.$$escapeHtml(opt_data.passportUrl), '</p>');
      el8.template.print.letter.attachments.tableOfContents(opt_data, output);
    } else {
      output.append('<div class="ml20"><p>To accompany this letter, ', soy.$$escapeHtml(opt_data.signUserName), ' has prepared an interactive patient chart for you to view online. Anyone in your practice can access the chart following the instructions below:</p><ol class="numberedList mt10"><li class="item">Go to <b>', soy.$$escapeHtml(opt_data.passportUrl), '</b></li><li class="item">Enter this Reference Code: <b>', soy.$$escapeHtml(opt_data.passportCode), '</b></li></ol>');
      el8.template.print.letter.attachments.tableOfContents(opt_data, output);
      output.append('</div>');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};
